// client/src/components/pedidos/FiltroPedidos.js
import React, { useState, useCallback } from 'react';
import { Search, Filter, X } from 'lucide-react';

const FiltroPedidos = ({ onApplyFilters, loading }) => {
    const [filters, setFilters] = useState({
        search: '',
        status: '',
        tipo: '',
        tipoEntrega: '',
        dataInicio: '',
        dataFim: ''
    });

    const statusOptions = [
        { value: '', label: 'Todos os status' },
        { value: 'pendente', label: 'Pendente' },
        { value: 'confirmado', label: 'Confirmado' },
        { value: 'preparando', label: 'Em Preparação' },
        { value: 'pronto_entrega', label: 'Pronto para Entrega' },
        { value: 'enviado', label: 'Enviado' },
        { value: 'entregue', label: 'Entregue' },
        { value: 'cancelado', label: 'Cancelado' }
    ];

    const tipoOptions = [
        { value: '', label: 'Todos os tipos' },
        { value: 'produtos', label: 'Produtos' },
        { value: 'servicos', label: 'Serviços' },
        { value: 'misto', label: 'Misto' }
    ];

    const entregaOptions = [
        { value: '', label: 'Todos' },
        { value: 'entrega', label: 'Entrega' },
        { value: 'retirada', label: 'Retirada' }
    ];

    const handleFilterChange = useCallback((key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    }, []);

    const handleApply = useCallback(() => {
        const activeFilters = {};
        
        if (filters.search) activeFilters.search = filters.search;
        if (filters.status) activeFilters.status = filters.status;
        if (filters.tipo) activeFilters.tipo = filters.tipo;
        if (filters.tipoEntrega) activeFilters.tipoEntrega = filters.tipoEntrega;
        if (filters.dataInicio) activeFilters.dataInicio = filters.dataInicio;
        if (filters.dataFim) activeFilters.dataFim = filters.dataFim;

        onApplyFilters(activeFilters);
    }, [filters, onApplyFilters]);

    const handleClear = useCallback(() => {
        setFilters({
            search: '',
            status: '',
            tipo: '',
            tipoEntrega: '',
            dataInicio: '',
            dataFim: ''
        });
        onApplyFilters({});
    }, [onApplyFilters]);

    const hasActiveFilters = Object.values(filters).some(value => value !== '');

    return (
        <div className="filtro-pedidos">
            <div className="form-grid-container-auto-fit">
                <div className="form-group">
                    <label>Buscar</label>
                    <div className="search-box">
                        <Search size={18} />
                        <input
                            type="text"
                            placeholder="Nº pedido, cliente..."
                            value={filters.search}
                            onChange={(e) => handleFilterChange('search', e.target.value)}
                            className="search-input"
                        />
                        {filters.search && (
                            <button
                                type="button"
                                onClick={() => handleFilterChange('search', '')}
                                className="clear-search-button"
                            >
                                <X size={16} />
                            </button>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label>Status</label>
                    <select
                        value={filters.status}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        className="form-input"
                    >
                        {statusOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Tipo</label>
                    <select
                        value={filters.tipo}
                        onChange={(e) => handleFilterChange('tipo', e.target.value)}
                        className="form-input"
                    >
                        {tipoOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Entrega</label>
                    <select
                        value={filters.tipoEntrega}
                        onChange={(e) => handleFilterChange('tipoEntrega', e.target.value)}
                        className="form-input"
                    >
                        {entregaOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Data Início</label>
                    <input
                        type="date"
                        value={filters.dataInicio}
                        onChange={(e) => handleFilterChange('dataInicio', e.target.value)}
                        className="form-input"
                    />
                </div>

                <div className="form-group">
                    <label>Data Fim</label>
                    <input
                        type="date"
                        value={filters.dataFim}
                        onChange={(e) => handleFilterChange('dataFim', e.target.value)}
                        className="form-input"
                    />
                </div>
            </div>

            <div className="filtro-actions">
                <button
                    onClick={handleApply}
                    disabled={loading}
                    className="action-button action-button-primary"
                >
                    <Filter size={16} />
                    Aplicar Filtros
                </button>

                {hasActiveFilters && (
                    <button
                        onClick={handleClear}
                        disabled={loading}
                        className="action-button action-button-secondary"
                    >
                        <X size={16} />
                        Limpar Filtros
                    </button>
                )}
            </div>
        </div>
    );
};

export default FiltroPedidos;